import { render, staticRenderFns } from "./qaitemanswer.vue?vue&type=template&id=4cf67b2a&"
import script from "./qaitemanswer.vue?vue&type=script&lang=js&"
export * from "./qaitemanswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports